import { Radius, Spacing } from "components/designV2/constants";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const SubscriptionPageLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.xl}px;
`;

export const SubscriptionCard = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  padding: ${Spacing.lg}px;
  border-radius: ${Radius.xl}px;
  background: ${ColorV2.Blue7};
`;

export const SubscriptionCardTitle = styled.h2`
  ${TypographyV2.h5}
  margin: 0;
  color: ${ColorV2.Blue1};
`;

export const SubscriptionValue = styled.div`
  ${TypographyV2.b1}
  color: ${ColorV2.Blue1};
`;

export const SubscriptionSupportingText = styled.div`
  ${TypographyV2.s1}
  color: ${ColorV2.Blue4};
`;

export const TermsLinks = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;
